import { Component, forwardRef, HostBinding, Input } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  UntypedFormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { BuildingErrors } from 'app/shared/errors/error-messages';
import { getError } from '@shared/utils/error.utils';
import { clearField } from '@shared/utils/form-field.utils';
import {
  BuildingClasses,
  BuildingControlName,
  BuildingLabel,
  BuildingMaxLength,
  BuildingPlaceholder,
} from './building.constants';

@Component({
  selector: 'app-building',
  templateUrl: './building.component.html',
  styleUrls: ['./building.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BuildingComponent),
      multi: true,
    },
  ],
})
export class BuildingComponent implements ControlValueAccessor {
  protected readonly getError = getError;
  protected readonly clearField = clearField;

  BuildingErrors = BuildingErrors;

  @Input() formControl: UntypedFormControl | AbstractControl = new UntypedFormControl('');

  @Input() placeholder: string = BuildingPlaceholder;

  @Input() label: string = BuildingLabel;

  @Input() testId: string = BuildingControlName;

  @Input() minLength: number = BuildingMaxLength;

  @Input() maxLength: number = BuildingMaxLength;

  @Input() clearEnabled: boolean = false;

  @Input()
  @HostBinding('class')
  classList = BuildingClasses;

  get building(): AbstractControl {
    return this.formControl;
  }

  registerOnChange(fn: any): void {}

  registerOnTouched(fn: any): void {}

  writeValue(obj: any): void {
    if (obj === this.formControl.value) {
      return;
    }
    this.formControl.setValue(obj);
  }
}
